import { useBlockReleaseRequestContext } from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestContext/BlockReleaseRequestContext';
import React from 'react';
import { BlockReleaseState } from '@data/blockReleases/types/BlockReleaseState';
import { DEFAULT_SELECTION_ALL } from '@utilities/constants';

export const useGetFilteredReleases = () => {
	const { releases, selectedSurgeonFilter } = useBlockReleaseRequestContext();

	const filterReleases = React.useCallback(
		(state: BlockReleaseState[]) => {
			return releases?.filter((release) => {
				const matchesSurgeonNpi =
					selectedSurgeonFilter === DEFAULT_SELECTION_ALL ||
					release.npis[0].toString() === selectedSurgeonFilter;
				let matchesState = state.includes(release.state);
				if (release.state === BlockReleaseState.FLIP_RECOMMENDATION) {
					matchesState =  !!release.originalReleases?.every((originalRelease) => state.includes(originalRelease.state));
				}
				return matchesState && matchesSurgeonNpi;
			});
		},
		[releases, selectedSurgeonFilter],
	);

	const recommendedReleases = React.useMemo(
		() =>
			filterReleases([BlockReleaseState.RECOMMENDED_RELEASE, BlockReleaseState.NOT_RELEASED]),
		[filterReleases],
	);

	const pendingReleases = React.useMemo(
		() => filterReleases([BlockReleaseState.PENDING_RELEASE]),
		[filterReleases],
	);

	return {
		recommendedReleases,
		pendingReleases,
	};
};
